import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'phosphor-react';
import { formatPhoneLabel } from '@sluitstraat/core';
import { woonhuisStyles as styles } from '../../../styles/commonStyles';

// Presentational warning card for uninsurable/blocked property situations, moved verbatim from
// WoonhuisScreen. Rendered twice: monument warning (id="monument-warning" — handleNext scrolls
// to this id, keep it stable) and rented warning (id="rented-warning"). The surrounding
// conditionals (isMonumentProperty / isInboedelBlockedByRental) stay in the screen.

interface PropertyWarningProps {
  id: string;
  titleKey: string;
  messageKey: string;
  contactInfo: { phone: string; email: string };
}

export const PropertyWarning: React.FC<PropertyWarningProps> = ({ id, titleKey, messageKey, contactInfo }) => {
  const { t } = useTranslation();

  return (
    <div id={id} style={styles.monumentWarning}>
      <div style={styles.monumentWarningIcon}>
        <Info size={24} />
      </div>
      <div style={styles.monumentWarningContent}>
        <div style={styles.monumentWarningTitle}>
          {t(titleKey)}
        </div>
        <div style={styles.monumentWarningText}>
          {t(messageKey)}
        </div>
        {(contactInfo.phone || contactInfo.email) && (
          <div style={styles.monumentWarningContact}>
            {contactInfo.phone && (
              <div>
                <a href={`tel:${contactInfo.phone}`} style={styles.monumentWarningLink}>
                  {formatPhoneLabel(contactInfo.phone)}
                </a>
              </div>
            )}
            {contactInfo.email && (
              <div>
                <a href={`mailto:${contactInfo.email}`} style={styles.monumentWarningLink}>
                  {contactInfo.email}
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
